import { ReactNode, useRef } from "react";

import {
  DefaultCloseFunc,
  UseFormDirtyGuardProps,
  useFormDirtyGuard,
} from "@/common/hooks/form/useFormDirtyGuard";

import { FormWrapperHandle } from "../Entity/components/BaseEntityCreateUpdate";
import AppModal, { AppModalChildrenParams, AppModalProps } from "./AppModal";

export interface AppModalWithGuardsProps extends Omit<AppModalProps, "children"> {
  guards: {
    /** Confirm modal close if form is dirty. */
    formDirty?: Pick<UseFormDirtyGuardProps<DefaultCloseFunc>, "formWrapperRef" | "confirmMessage">;
  };
  children: (params: AppModalChildrenParams) => ReactNode;
}

export function AppModalWithGuards({
  guards,
  onClose,
  children,
  ...otherProps
}: AppModalWithGuardsProps) {
  const formWrapperStubRef = useRef<FormWrapperHandle | null>(null);

  const formDirtyGuard = useFormDirtyGuard({
    formWrapperRef: guards.formDirty?.formWrapperRef || formWrapperStubRef,
    onClose: onClose,
  });

  return (
    <AppModal {...otherProps} onClose={formDirtyGuard.handleClose}>
      {(params) => children(params)}
    </AppModal>
  );
}
